import { Domain } from '@repo/domain';
export class MockRepository {
    config;
    constructor(config = {}) {
        this.config = config;
    }
    capabilities = {
        [Domain.BankAccount]: async () => {
            return (MockRepository.bankAccountRepoPromise ??= import('./repositories/BankAccountRepository').then((module) => {
                return new module.BankAccountRepository();
            }));
        },
        [Domain.Billing]: async () => {
            return (MockRepository.billingRepoPromise ??= import('./repositories/BillingRepository').then((module) => {
                return new module.BillingRepository();
            }));
        },
        [Domain.Consent]: async () => {
            return (MockRepository.consentRepoPromise ??= import('./repositories/ConsentRepository').then((module) => {
                return new module.ConsentRepository();
            }));
        },
        [Domain.Gate]: async () => {
            return (MockRepository.gateRepoPromise ??= import('./repositories/GateRepository').then((module) => {
                return new module.GateRepository();
            }));
        },
        [Domain.OwnedParking]: async () => {
            return (MockRepository.ownedParkingRepoPromise ??= import('./repositories/OwnedParkingRepository').then((module) => {
                return new module.OwnedParkingRepository();
            }));
        },
        [Domain.OwnedParkingImage]: async () => {
            return (MockRepository.ownedParkingImageRepoPromise ??= import('./repositories/OwnedParkingImageRepository').then((module) => {
                return new module.OwnedParkingImageRepository();
            }));
        },
        [Domain.OwnedParkingPriceRule]: async () => {
            return (MockRepository.ownedParkingPriceRuleRepoPromise ??=
                import('./repositories/OwnedParkingPriceRuleRepository').then((module) => {
                    return new module.OwnedParkingPriceRuleRepository();
                }));
        },
        [Domain.OwnedParkingSpot]: async () => {
            return (MockRepository.ownedParkingSpotRepoPromise ??= import('./repositories/OwnedParkingSpotRepository').then((module) => {
                return new module.OwnedParkingSpotRepository();
            }));
        },
        [Domain.Parking]: async () => {
            return (MockRepository.parkingRepoPromise ??= import('./repositories/ParkingRepository').then((module) => {
                return new module.ParkingRepository();
            }));
        },
        [Domain.ParkingPath]: async () => {
            return (MockRepository.parkingPathRepoPromise ??= import('./repositories/ParkingPathRepository').then((module) => {
                return new module.ParkingPathRepository();
            }));
        },
        [Domain.ParkingVehicle]: async () => {
            return (MockRepository.parkingVehicleRepoPromise ??= import('./repositories/ParkingVehicleRepository').then((module) => {
                return new module.ParkingVehicleRepository();
            }));
        },
        [Domain.PartialParking]: async () => {
            return (MockRepository.partialParkingRepoPromise ??= import('./repositories/PartialParkingRepository').then((module) => {
                return new module.PartialParkingRepository();
            }));
        },
        [Domain.PaynowClause]: async () => {
            return (MockRepository.paynowClauseRepoPromise ??= import('./repositories/PaynowClauseRepository').then((module) => {
                return new module.PaynowClauseRepository();
            }));
        },
        [Domain.Pilot]: async () => {
            return (MockRepository.pilotRepoPromise ??= import('./repositories/PilotRepository').then((module) => {
                return new module.PilotRepository();
            }));
        },
        [Domain.Price]: async () => {
            return (MockRepository.priceRepoPromise ??= import('./repositories/PriceRepository').then((module) => {
                return new module.PriceRepository();
            }));
        },
        [Domain.User]: async () => {
            return (MockRepository.userRepoPromise ??= import('./repositories/UserRepository').then((module) => {
                return new module.UserRepository(this.config);
            }));
        },
        [Domain.Reservation]: async () => {
            return (MockRepository.reservationRepoPromise ??= import('./repositories/ReservationRepository').then((module) => {
                return new module.ReservationRepository();
            }));
        },
        [Domain.ReverseGeocodedAddress]: async () => {
            return (MockRepository.reverseGeocodedAddressRepoPromise ??=
                import('./repositories/ReverseGeocodedAddressRepository').then((module) => {
                    return new module.ReverseGeocodedAddressRepository();
                }));
        },
        [Domain.Sign]: async () => {
            return (MockRepository.signRepoPromise ??= import('./repositories/SignRepository').then((module) => {
                return new module.SignRepository();
            }));
        },
        [Domain.UnauthorizedUseCase]: async () => {
            return (MockRepository.unauthorizedUseCaseRepoPromise ??=
                import('./repositories/UnauthorizedUseCaseRepository').then((module) => {
                    return new module.UnauthorizedUseCaseRepository();
                }));
        },
        [Domain.UnavailabilityDay]: async () => {
            return (MockRepository.unavailabilityDayRepoPromise ??= import('./repositories/UnavailabilityDayRepository').then((module) => {
                return new module.UnavailabilityDayRepository();
            }));
        },
        [Domain.Vehicle]: async () => {
            return (MockRepository.vehicleRepoPromise ??= import('./repositories/VehicleRepository').then((module) => {
                return new module.VehicleRepository();
            }));
        },
    };
    static bankAccountRepoPromise;
    static billingRepoPromise;
    static consentRepoPromise;
    static gateRepoPromise;
    static ownedParkingImageRepoPromise;
    static ownedParkingPriceRuleRepoPromise;
    static ownedParkingRepoPromise;
    static ownedParkingSpotRepoPromise;
    static parkingPathRepoPromise;
    static parkingVehicleRepoPromise;
    static parkingRepoPromise;
    static partialParkingRepoPromise;
    static paynowClauseRepoPromise;
    static pilotRepoPromise;
    static priceRepoPromise;
    static reservationRepoPromise;
    static reverseGeocodedAddressRepoPromise;
    static signRepoPromise;
    static unauthorizedUseCaseRepoPromise;
    static unavailabilityDayRepoPromise;
    static userRepoPromise;
    static vehicleRepoPromise;
}
